import React from 'react'

import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'

import Advisor from './Advisor'

export interface ILauncherProps {}

const Launcher: React.FC<ILauncherProps> = (props: ILauncherProps) => {
  const [show, setShow] = React.useState<boolean>(false)

  return (
    <>
      <Container fluid>
        <Row>
          <Col className='text-center'>
            <Button
              variant='primary'
              className='me-2 mb-2 text-light lead p-3'
              onClick={() => {
                setShow(true)
                ;(window as any).dataLayer = (window as any).dataLayer || []
                ;(window as any).dataLayer.push({
                  event: 'advisorLaunched',
                })
              }}>
              Start WPO365 Advisor
            </Button>
          </Col>
        </Row>
      </Container>
      <Modal size='lg' centered show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>WPO365 Advisor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Advisor />
        </Modal.Body>
      </Modal>
    </>
  )
}

export default Launcher
